var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdgeGatewayLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_629_108283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 19,
    stroke: "#002D9C",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2495 17.5001C29.1245 17.5001 28.1245 18.2501 27.812 19.3751H26.812L23.2495 13.4376C23.187 13.2501 22.937 13.1251 22.7495 13.1251H20.187C19.812 11.8126 18.437 11.0001 17.1245 11.3126C15.812 11.6251 14.9995 13.0626 15.312 14.3751C15.6245 15.6876 16.9995 16.5001 18.3745 16.1876C19.2495 15.9376 19.937 15.2501 20.187 14.3751H22.437L25.437 19.3751H20.187C19.812 18.0626 18.4995 17.2501 17.1245 17.5626C15.812 17.9376 14.9995 19.2501 15.312 20.6251C15.6245 22.0001 16.9995 22.7501 18.3745 22.4376C19.2495 22.1876 19.937 21.5001 20.187 20.6251H25.437L22.437 25.6251H20.187C19.812 24.3126 18.4995 23.5001 17.1245 23.8126C15.812 24.1876 14.9995 25.5001 15.312 26.8751C15.6245 28.2501 16.9995 29.0001 18.3745 28.6876C19.2495 28.4376 19.937 27.7501 20.187 26.8751H22.7495C22.9995 26.8751 23.187 26.7501 23.312 26.5626L26.8745 20.6251H27.8745C28.2495 21.9376 29.562 22.7501 30.937 22.4376C32.2495 22.0626 33.062 20.7501 32.7495 19.3751C32.3745 18.2501 31.3745 17.5001 30.2495 17.5001ZM17.7495 15.0001C17.062 15.0001 16.4995 14.4376 16.4995 13.7501C16.4995 13.0626 17.062 12.5001 17.7495 12.5001C18.437 12.5001 18.9995 13.0626 18.9995 13.7501C18.9995 14.4376 18.437 15.0001 17.7495 15.0001ZM17.7495 21.2501C17.062 21.2501 16.4995 20.6876 16.4995 20.0001C16.4995 19.3126 17.062 18.7501 17.7495 18.7501C18.437 18.7501 18.9995 19.3126 18.9995 20.0001C18.9995 20.6876 18.437 21.2501 17.7495 21.2501ZM17.7495 27.5001C17.062 27.5001 16.4995 26.9376 16.4995 26.2501C16.4995 25.5626 17.062 25.0001 17.7495 25.0001C18.437 25.0001 18.9995 25.5626 18.9995 26.2501C18.9995 26.9376 18.437 27.5001 17.7495 27.5001ZM30.2495 21.2501C29.562 21.2501 28.9995 20.6876 28.9995 20.0001C28.9995 19.3126 29.562 18.7501 30.2495 18.7501C30.937 18.7501 31.4995 19.3126 31.4995 20.0001C31.4995 20.6876 30.937 21.2501 30.2495 21.2501Z",
    fill: "#002D9C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_629_108283",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_108283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_108283",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeGatewayLegend);
export default __webpack_public_path__ + "static/media/edgeGatewayLegend.1647424343f056382702233073d9ed08.svg";
export { ForwardRef as ReactComponent };